'use client';
import React, { ReactNode } from 'react';
import { useLenis } from '@hooks/useLenis';
import cn from './style.module.scss';

interface AnimatedDownArrowProps {
  children?: ReactNode;
  variant?: 'white' | 'black' | 'color';
  scrollToId?: string;
  scrollOffset?: number;
  url?: string;
  className?: string;
  onClick?: () => void;
}

export default function AnimatedDownArrow({
  children,
  variant = 'black',
  scrollToId,
  scrollOffset = 0,
  url,
  onClick,
  className = '',
}: AnimatedDownArrowProps) {
  const { scrollTo } = useLenis();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick();
      return;
    }

    if (scrollToId) {
      e.preventDefault();
      scrollTo(`#${scrollToId}`, { offset: scrollOffset });
      return;
    }

    if (url?.startsWith('#')) {
      e.preventDefault();
      scrollTo(url, { offset: scrollOffset });
    }
  };

  const href = url || (scrollToId ? `#${scrollToId}` : undefined);

  return (
    <div className={cn.animatedArrowBlock}>
      <a
        href={href}
        onClick={handleClick}
        className={`${cn.animatedArrowElement} ${cn[variant] || ''} ${className}`}
      >
        {children}
      </a>
    </div>
  );
}
